import { Suspense } from 'react'

 
export function withSuspense<T extends object>(
  WrappedComponent: React.ComponentType<T>,
  FallbackComponent: React.ComponentType<T>,
): React.ComponentType<T> {
  // make it easy to spot missing suspense fallbacks in development
  if (process.env.NODE_ENV === 'development') {
    const FallbackComponentOriginal = FallbackComponent

    const FallbackComponentWithLog = (props: T) => {
      // biome-ignore lint/suspicious/noConsoleLog: <explanation>
      console.log('Rendering fallback component...')
      return <FallbackComponentOriginal {...props} />
    }
    FallbackComponentWithLog.displayName = FallbackComponentOriginal.displayName || FallbackComponentOriginal.name
    FallbackComponent = FallbackComponentWithLog
  }
  const ComponentWithSuspense = (props: T) => (
    <Suspense fallback={<FallbackComponent {...props} />}>
      <WrappedComponent {...props} />
    </Suspense>
  )

  ComponentWithSuspense.displayName = WrappedComponent.displayName || WrappedComponent.name

  return ComponentWithSuspense
}
 
